import React, { SVGProps } from 'react';

export const HourGlass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.4 3h-1.8v1.667A6.54 6.54 0 0 1 16.2 9.73l-2.827 2.31 2.692 2.234a6.54 6.54 0 0 1 2.363 5.032V21H20.4v1.8H3.6V21h1.8v-1.667a6.54 6.54 0 0 1 2.401-5.064l2.74-2.24-2.778-2.304A6.54 6.54 0 0 1 5.4 4.693V3H3.6V1.2h16.8V3ZM8.94 15.663a4.74 4.74 0 0 0-1.74 3.67V21h9.427v-1.693a4.74 4.74 0 0 0-1.712-3.647L11.951 13.2 8.94 15.663ZM7.2 4.693A4.74 4.74 0 0 0 8.913 8.34l3.048 2.53 3.099-2.533a4.74 4.74 0 0 0 1.74-3.67V3H7.2v1.693Z"
    />
  </svg>
);
